export default __webpack_public_path__ + "static/banner-festive-fashion-185599c47a0fe31042e60fcdb82be514.jpg";